module.exports = __webpack_public_path__ + "img/w3_delivery_light.f554b49e.png";